import { klona } from 'klona'
import { useRouter } from 'next/router'
import React from 'react'
import { useAuth } from '../hooks/useAuth'
import useMediaQuery from '../hooks/useMediaQuery'
import { formDataFromEvent } from '../utils/formDataFromEvent'
import { Button } from './Buttons'
import { Flex } from './Flex'
import { InputPassword } from './InputPassword'
import { MutationErrorMessage } from './MutationErrorMessage'
import { MutationSuccessMessage } from './MutationSuccessMessage'

export function ChangePasswordForm() {
	const isMobile = useMediaQuery('(max-width: 768px)')
	const locale = useRouter().locale
	const auth = useAuth()

	const [passInfo, setPassInfo] = React.useState<{ current: string; new: string }>({
		current: '',
		new: '',
	})

	return (
		<form
			onSubmit={(e) => {
				e.preventDefault()
				auth.changePassword.mutate(
					formDataFromEvent(e) as { currentPassword: string; newPassword: string }
				)
			}}>
			<fieldset disabled={auth.changePassword.isLoading}>
				<Flex itemsPerRow={2} mobileItemsPerRow={1} spacing={isMobile ? 30 : 90}>
					<InputPassword
						id="password"
						name="currentPassword"
						label={{
							isLabel: true,
							text: locale === 'cs' ? 'Aktuální heslo' : 'Current password',
						}}
						onChange={(e) => {
							const newPassInfo = klona(passInfo)
							newPassInfo.current = e.currentTarget.value
							setPassInfo(newPassInfo)
						}}
					/>
					<InputPassword
						id="newPassword"
						name="newPassword"
						label={{
							isLabel: true,
							text: locale === 'cs' ? 'Nové heslo' : 'New password',
						}}
						onChange={(e) => {
							const newPassInfo = klona(passInfo)
							newPassInfo.new = e.currentTarget.value
							setPassInfo(newPassInfo)
						}}
					/>
				</Flex>
				<div style={{ marginTop: '2em' }}>
					<Flex justifyContent="space-between">
						<div>
							<MutationErrorMessage mutation={auth.changePassword} />
							<MutationSuccessMessage mutation={auth.changePassword} />
						</div>
						<div style={{ textAlign: 'right' }}>
							<Button
								type="submit"
								fill="green600"
								disabled={!passInfo.current || !passInfo.new || passInfo.current === passInfo.new}>
								{locale === 'cs' ? 'Uložit nové heslo' : 'Save new password'}
							</Button>
						</div>
					</Flex>
				</div>
			</fieldset>
		</form>
	)
}
